import { Routes } from "@angular/router";
import { WorkflowCspOneAvailabilityComponent } from "./workflow-csp-one-availability.component";

export const workflowCspOneAvailabilityRouting: Routes = [
    {
        path: 'csp/availability/:aid', component: WorkflowCspOneAvailabilityComponent, children: [
            { path: 'select', component: WorkflowCspOneAvailabilityComponent },
            { path: 'contact-sales', component: WorkflowCspOneAvailabilityComponent },
            { path: 'address', component: WorkflowCspOneAvailabilityComponent },
            { path: 'payment', component: WorkflowCspOneAvailabilityComponent },
            { path: 'checkout', component: WorkflowCspOneAvailabilityComponent },
            { path: 'complete', component: WorkflowCspOneAvailabilityComponent },
            { path: 'downgrade', component: WorkflowCspOneAvailabilityComponent },
            { path: '', redirectTo: 'select', pathMatch: 'full' },
        ]
    },
]
